module.exports = __webpack_public_path__ + "img/Eye2.db1aa077.svg";